import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../axios";

export const getAutoReenableKiosk = createAsyncThunk(
  "settings/getAutoReenableKiosk",
  async () => {
    try {
      const response = await axios.get("/settings/auto-reenable-kiosk");
      return response.data;
    } catch (error) {
      const customError = {
        name: "Error fetching settings",
        message: error.response.data.message,
      };
      throw customError;
    }
  }
);

export const updateAutoReenableKiosk = createAsyncThunk(
  "settings/updateAutoReenableKiosk",
  async (autoReenableKiosk) => {
    try {
      const response = await axios.patch("/settings/auto-reenable-kiosk", {
        autoReenableKiosk,
      });
      return response.data;
    } catch (error) {
      const customError = {
        name: "Error updating settings",
        message: error.response.data.message,
      };
      throw customError;
    }
  }
);

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    autoReenableKiosk: false,
    loading: false,
  },
  reducers: {},
  extraReducers: {
    [getAutoReenableKiosk.pending]: (state) => {
      state.loading = true;
    },
    [getAutoReenableKiosk.rejected]: (state) => {
      state.loading = false;
    },
    [getAutoReenableKiosk.fulfilled]: (state, action) => {
      state.autoReenableKiosk = action.payload.autoReenableKiosk;
      state.loading = false;
    },
    [updateAutoReenableKiosk.fulfilled]: (state, action) => {
      state.autoReenableKiosk = action.payload.autoReenableKiosk;
    },
  },
});

export default settingsSlice.reducer;
